import styled from 'styled-components';
import {rem} from 'polished';
import {Button} from 'global/styles/styles.js';

const S = {};

const FontFamily = ({theme: {$fontFamily}}) => `${$fontFamily}`;
const FwSemibold = ({theme: {$fwSemibold}}) => `${$fwSemibold}`;
const FwRegular = ({theme: {$fwRegular}}) => `${$fwRegular}`;

const InputErrorColor = ({theme: {$inputErrorColor}}) => `${$inputErrorColor}`;
const InputColor = ({theme: {$inputColor}}) => `${$inputColor}`;
const InputLabelColor = ({theme: {$inputLabelColor}}) => `${$inputLabelColor}`;
const InputPlaceholderColor = ({theme: {$inputPlaceholderColor}}) => `${$inputPlaceholderColor}`;
const InputBackgroundColor = ({theme: {$inputBackgroundColor}}) => `${$inputBackgroundColor}`;
const SubmitButtonTextColor = ({theme: {$submitButtonTextColor}}) => `${$submitButtonTextColor}`;
const FormBackgroundColor = ({theme: {$formBackgroundColor}}) => `${$formBackgroundColor}`;
const HeaderTextColor = ({theme: {$headerTextColor}}) => `${$headerTextColor}`;
const ResendTextColor = ({theme: {$resendTextColor}}) => `${$resendTextColor}`;
const ResendButtonColor = ({theme: {$resendButtonColor}}) => `${$resendButtonColor}`;
const StepperPrimaryColor = ({theme: {$stepperPrimaryColor}}) => `${$stepperPrimaryColor}`;
const StepperAccentColor = ({theme: {$stepperAccentColor}}) => `${$stepperAccentColor}`;
const StepperBackgroundColor = ({theme: {$stepperBackgroundColor}}) => `${$stepperBackgroundColor}`;
const StepperTextColor = ({theme: {$stepperTextColor}}) => `${$stepperTextColor}`;

S.RegisterWizardForm = styled.div`
  padding: 1.5rem 1rem 1rem;
  height: 100%;
  background-color: ${FormBackgroundColor};
`;

S.RegisterWizardFormTitle = styled.h2`
  color: rgba(0, 0, 0, 0.87);
  text-align: center;
  font-size: 1.65rem;
  padding-top: 1.1875rem;
  font-weight: 400;
`;

S.InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

S.Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  height: ${rem('40px')};
  padding: 0 ${rem('12px')};
  border: 1px solid ${props => props.hasError ? InputErrorColor : InputColor};
  border-radius: 4px;
  font-size: ${rem('14px')};
  background: ${InputBackgroundColor};
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: ${props => props.hasError ? InputErrorColor : InputColor};
  }

  &::placeholder {
    color: ${InputPlaceholderColor};
  }
`;

S.FloatingLabel = styled.span`
  position: absolute;
  top: -8px;
  left: 12px;
  background: ${InputBackgroundColor};
  padding: 0 4px;
  font-size: ${rem('11px')};
  color: ${InputLabelColor};
  z-index: 1;
`;

S.CheckIcon = styled.span` 
  color: ${InputLabelColor};
  margin-left: auto; 
`;

S.ErrorText = styled.div` 
  color: ${InputErrorColor};
  font-size: 10px; 
  margin-top: 2px; 
`;

S.ConfirmationModal = styled.div`
   display: flex;
   flex-direction: column;
   flex: 1;
`;

S.ConfirmationMsg = styled.div`
  font-weight: 600;
  padding: .7rem;
`;

S.Title = styled.div`
  font-size: ${rem('26px')};
  padding-top: 40px;
  padding-bottom: 40px;
  font-weight: ${FwRegular};
  text-align: center;
  color: ${HeaderTextColor};
`;

S.ConfirmationCloseBtn = styled(Button)`
    display: block;
    background-color: ${({theme: {$registerFormConfirmationCloseBtnBgColor}}) => $registerFormConfirmationCloseBtnBgColor};
    height: 2.625rem;
    font-size: .75rem;
    font-weight: 500;
    padding: 0;
    width: 50%;
    margin: 1.5rem 0;
    color: #fff;
    border-radius: 3px;
    margin-left: auto;
    margin-right: auto; 
`;

S.HideIframe = styled.iframe`
    display: none;
`;

S.BellIcon = styled.div`
    width: 30px;
    height: 30px;
    margin: 0 auto;
     & svg {
       width: 100%;
        & .a {
            fill: #c62828 !important;
        }
    }
`;

S.ModalText = styled.div`
    padding-bottom: 1.25rem;
    padding-top: 0.625rem;
    font-size: 0.8125rem;
    padding: 0.625rem 2.5rem 1.25rem;
    line-height: 1.6;
    text-align: center;
`;

S.Modal = styled.div`
    z-index: 98;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;

    .confirm-modal-content {
        position: relative;
        z-index: 99;
        top: -110px;
        width: calc(90% - 32px);
        background-color: #fff;
        box-shadow: rgba(0, 0, 0, 0.26) 0px 19px 38px;
        border-radius: 2px;
        padding: 20px 16px;
        height: auto;

        .buttonsWrapper {
            display: flex;
            justify-content: space-between;  
        }
    }
`;
 
S.ModalButton = styled.button`
    width: 8.875rem;
    height: 2.625rem;
    box-sizing: border-box;
    padding: 0;
    border-radius: 3px;
    border: ${props => props.cancel ? "1px solid #C62828" : "none"};
    color: ${props => props.cancel ? "#C62828" : "#fff"};
    background-color: ${props => props.cancel ? "#fff" : "#C62828"};  
`;

S.SubmitBtn = styled.button`
  width: 100%;
  height: ${rem('40px')};
  background-color: ${InputErrorColor};
  color: ${SubmitButtonTextColor};
  border: none;
  border-radius: 4px;
  font-weight: ${FwSemibold};
  margin-top: 24px;
  cursor: pointer;
  text-transform: uppercase;

  &:disabled {
    opacity: 0.6; 
    cursor: not-allowed;
  }
`;

S.ResendText = styled.div`
  font-weight: ${FwRegular};
  font-size: ${rem('11px')};
  color: ${ResendTextColor};
  margin-bottom: ${rem('15px')};
`;

S.ResendCounter = styled.div`
  font-weight: ${FwRegular};
  font-size: ${rem('11px')};
  color: ${ResendTextColor};
`;

S.ResendButton = styled.div`
  color: ${ResendButtonColor};
  font-weight: ${FwSemibold};
  cursor: pointer;
  font-size: ${rem('11px')};
`;

S.Stepper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: ${props => props.stepsCount === 3 ? rem('300px') : rem('280px')};
  position: relative;
  padding-bottom: 40px;
  margin: 0 auto;
`;

S.StepWrapper = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;

  &:not(:last-child):after {
    content: '';
    position: absolute;
    top: ${rem('13px')}; 
    left: 50%; 
    width: 100%; 
    height: 1px;
    background-color: ${StepperPrimaryColor};
    z-index: 1;
  }
`;

S.Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  cursor: ${props => props.hasPointer ? 'pointer' : 'default'};
`;

S.StepCircle = styled.div`
  width: ${rem('26px')};
  height: ${rem('26px')};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.isActive ? StepperAccentColor : StepperBackgroundColor};
  border: 1px solid ${props => props.isActive ? StepperAccentColor : StepperPrimaryColor};
  color: ${props => props.isActive ? StepperTextColor : StepperPrimaryColor};
  z-index: 2;
  transition: all 0.2s;
`;

S.StepLabel = styled.div`
  margin-top: ${rem('8px')};
  font-size: ${rem('10px')};
  text-align: center;
  color: ${props => props.isActive ? StepperAccentColor : 'rgba(0, 0, 0, 0.38)'};
  font-weight: ${props => props.isCurrent ? FwSemibold : FwRegular};
  width: 100%;
`;

S.Dialog = styled.div`
   width:  ${rem('335px')};
   padding: ${rem('16px')};
   box-shadow: 0 19px 38px #00000042;

`;

S.DialogBtnOk = styled(Button)`
 width:  ${rem('142px')};
 min-height:  ${rem('42px')};
 text-transform: uppercase;
 color: #fff;
 background-color: #C62828;
 border-radius: 3px;
 font-weight: ${FwSemibold};
`;

S.DialogBtnCancel = styled(S.DialogBtnOk)`
 color: #C62828;
 background-color: #fff;
 border: 1px solid #C62828;
`;

S.DialogText =styled.div`
  font-size: ${rem('13px')};
  color: #000;
      text-align: center;
`;

export default S;